import { Card } from '@client/toolkit';
import { useGetTenantsCurrentCompanyQuery } from '@client/api';
import { InvoiceOverview } from '../../../components/invoice-overview';

export function ProfileInvoices() {
  const { data: company } = useGetTenantsCurrentCompanyQuery();

  if (!company?.id) return null;

  return (
    <Card>
      <InvoiceOverview companyId={company.id} autoFetch />
    </Card>
  );
}
